var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 473.681 473.681",
    style: {
      enableBackground: "new 0 0 473.681 473.681"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 236.85,
    cy: 236.85,
    r: 236.83
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D32027"
    },
    d: "M0.002,236.842c0,89.021,49.142,166.531,121.749,206.989V29.842 C49.144,70.304,0.002,147.81,0.002,236.842z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M236.837,473.677c-2.726,0-5.348-0.093-8.021-0.138C231.473,473.628,234.146,473.677,236.837,473.677 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7E7E7"
    },
    d: "M236.837,0c-0.075,0-0.138,0.004-0.213,0.004C236.697,0.004,236.764,0,236.837,0 c130.807,0,130.807,473.681,0,473.681c41.704,0,80.861-10.819,114.898-29.741V29.737C317.697,10.815,278.54,0,236.837,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B52025"
    },
    d: "M351.734,29.737v414.199c72.716-40.429,121.944-117.999,121.944-207.094 C473.678,147.736,424.451,70.166,351.734,29.737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F1F2"
    },
    d: "M236.837,0c-0.075,0-0.138,0-0.213,0c-41.696,0.037-80.853,10.89-114.876,29.842v413.986 c31.887,17.767,68.292,28.417,107.068,29.707c2.674,0.045,5.295,0.138,8.021,0.138C367.643,473.677,367.643,0,236.837,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D32027"
    },
    d: "M328.747,232.56c-3.257-3.111-9.94-2.767-11.133-7.939c-1.578-12.703,4.267-20.1,7.954-28.589 c-18.66,4.364-33.372,11.548-33.357-9.528c-10.714,13.1-22.232,26.199-26.989,23.821c-6.757-3.971,6.484-37.687,7.932-55.578 c-6.537,2.984-19.057,9.528-19.057,9.528s-11.38-22.258-17.404-33.237v-0.12c-0.022,0.022-0.022,0.041-0.03,0.06 c-0.015-0.015-0.015-0.037-0.03-0.06v0.12c-6.032,10.979-17.404,33.237-17.404,33.237s-12.528-6.544-19.057-9.528 c1.44,17.894,14.682,51.61,7.924,55.578c-4.76,2.382-16.275-10.721-26.981-23.821c0,21.076-14.704,13.893-33.357,9.528 c3.68,8.485,9.525,15.882,7.932,28.589c-1.174,5.172-7.861,4.828-11.118,7.939c21.648,21.641,59.168,37.714,41.296,55.581 l48.184-4.495c1.578,16.282-3.519,36.263,0.905,47.38c1.036,0,0.696,0,1.672,0c0.015,0,0.037,0,0.06,0c0.972,0,0.613,0,1.642,0 c4.514-11.518-0.643-31.095,0.935-47.38l48.177,4.495C269.588,270.274,307.107,254.201,328.747,232.56z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCad);
export default __webpack_public_path__ + "static/media/cad.72bff97701b714d854c55447d3c6f92e.svg";
export { ForwardRef as ReactComponent };